<template>
  <v-app class="mv-vertical-nav">
    <!-- <default-bar /> -->

    <default-drawer />

    <default-view />

    <!-- <default-settings /> -->
  </v-app>
</template>

<script>
import store from "@store";

export default {
  name: "DefaultLayout",

  data() {
    return {};
  },

  components: {
    // DefaultBar: () => import("@/components/appbar/mv-vertical-appbar.vue"),
    DefaultDrawer: () =>
      import("@/components/navigation/mv-vertical-navi-drawer.vue"),
    // DefaultSettings: () => import(
    //   /* webpackChunkName: "default-settings" */
    //   '../navigation/Settings'
    // ),
    DefaultView: () =>
      import("@/components/contentview/mv-vertical-content-view.vue"),
  },
  created() { },
  mounted() {
    let user = localStorage.getItem("key_userObject");
    store.set("app/isLogined", user != null);
  },
  methods: {},
  destroyed() {}, //生命周期-销毁之前
};
</script>

<style lang="scss">
// @import "~vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css";
</style>
